export const MAX_MESSAGE_LENGTH = 4000;
export const MAX_FILE_SIZE = 50 * 1024 * 1024;
export const MAX_FILES_PER_MESSAGE = 5;

export const SUPPORTED_FILE_TYPES = [
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'text/plain',
  'text/csv',
  'application/json',
  'text/markdown',
  'text/x-markdown',
  'image/png',
  'image/jpeg',
  'image/gif',
  'image/webp',
  'image/svg+xml',
  'video/webm',
  'video/mp4',
  'audio/mpeg',
  'audio/wav',
  'audio/webm',
  'application/zip',
  'application/x-zip-compressed',
] as const;
